function serializePayload(payload) {
    return btoa(encodeURIComponent(JSON.stringify(payload)));
}

export { serializePayload };
